// import React, { useState, useEffect } from "react";
// import APICall from "../../Utility/APICall";
// import { paths } from "../../Utility/Constants";
// import { useAuth } from "../../Utility/AuthProvider";
// import Lottie from "lottie-react";
// import loaderAnimation from "../../assets/animations/loader.json";
// import PaymentModal from "../Modals/PaymenModal";
// import GenericTable from "../GenericTable"; // Import the GenericTable component
// import { MdDeleteForever } from "react-icons/md";
// import * as XLSX from "xlsx";

// const CustomComponent = ({ displayAll }) => {
//   const { jwt } = useAuth();
//   const [data, setData] = useState([]);
//   const [groupedData, setGroupedData] = useState({});
//   const [nextPageToken, setNextPageToken] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [showPaymentModal, setShowPaymentModal] = useState(false);
//   const [selectedPayment, setSelectedPayment] = useState(null);

//   const fetchData = async (pageToken) => {
//     try {
//       if (nextPageToken === "END") return;
//       setLoading(true);
//       const response = await APICall(
//         "POST",
//         paths.payments.fetch,
//         { next_page_token: pageToken ?? "" },
//         undefined,
//         jwt
//       );

//       let newPayments = response.response.payments;
//       if (!displayAll) {
//         newPayments = newPayments.slice(0, 5); // Limit to 5 records if displayAll is false
//       }

//       const updatedData = [...data, ...newPayments]; // Append new data

//       setData(updatedData);
//       setGroupedData(groupByMonth(updatedData));
//       setNextPageToken(response.response.next_page_token);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       setLoading(false);
//     }
//   };
//   // console.log("Data state before deletion 💋:", data);
//   console.log("THe data for down loading and showing table :", data);
//   // Handle delete with a specific entity_id
//   const handleDelete = async (transaction_id, month, year, isCheck) => {
//     try {
//       console.log("Entity ID to delete:", transaction_id);

//       // Construct the query string
//       const queryParams = new URLSearchParams({
//         transaction_id: transaction_id,
//         month: month,
//         year: year,
//         is_check: isCheck,
//       }).toString();

//       const urlWithParams = `${paths.payments.delete}?${queryParams}`;
//       console.log("API Request URL: ", urlWithParams);

//       const response = await APICall(
//         "DELETE",
//         urlWithParams,
//         undefined,
//         undefined,
//         jwt
//       );

//       console.log("API Response:", response);

//       if (response.status) {
//         // Remove the deleted item from the data array
//         const updatedData = data.filter(
//           (item) => item.entity_id !== transaction_id
//         );

//         // Update state to reflect the deletion
//         setData(updatedData);
//         setGroupedData(groupByMonth(updatedData)); // Update grouped data if applicable

//         console.log("Deleted successfully. Updated data:", updatedData);
//       } else {
//         console.error("Failed to delete:", response.error);
//       }
//     } catch (error) {
//       console.error("Error during delete operation:", error);
//     }
//   };

//   // console.log("Data state after deletion 😈💋  :", data);

//   // useEffect(() => {
//   //   console.log("Data updated:", data);
//   // }, [data]);

//   const groupByMonth = (data) => {
//     return data.reduce((acc, item) => {
//       const month = new Date(item.local_date).toLocaleString("default", {
//         month: "long",
//         year: "numeric",
//       });
//       if (!acc[month]) {
//         acc[month] = [];
//       }
//       acc[month].push(item);
//       return acc;
//     }, {});
//   };

//   useEffect(() => {
//     fetchData(null);
//   }, [jwt]);

//   const handleNext = () => {
//     if (nextPageToken && nextPageToken !== "END") {
//       fetchData(nextPageToken);
//     }
//   };

//   // const downloadCSV = () => {
//   //   const headers = [
//   //     "Description/Deposite Type",
//   //     "Building & Unit",
//   //     "Tenant Name",
//   //     "Date",
//   //     "Rent For Month",
//   //     "Status",
//   //     "Amount",
//   //   ];
//   //   // const headers = ["Description/Deposite Type", b "Tenant Name", "Date", "Status", "Amount"];
//   //   // const headers = ["Description/Deposite Type", "Tenant Name", "Date", "Status", "Amount"];
//   //   const rows = data.map((item) => [
//   //     `"${item.nature.charAt(0) + item.nature.slice(1)}"`,
//   //     `"${item.building_name && item.unit_name ? `(B)-${item.building_name}(U)-${item.unit_name}` : ""}"`,
//   //     `"${item.tenant_name.charAt(0) + item.tenant_name.slice(1)}"`,
//   //     `"${item.local_date}"`,
//   //     `"${item.month}"`,
//   //     `"${item.payment_status === "success" ? "Paid" : "Not Paid"}"`,
//   //     // `"${item.tenant_name}"`,
//   //     // `"${item.local_date}"`,
//   //     // `"${item.payment_status}"`,
//   //     `"${item.local_amount}"`,
//   //   ]);

//   //   let csvContent =
//   //     "data:text/csv;charset=utf-8," +
//   //     headers.join(",") +
//   //     "\n" +
//   //     rows.map((row) => row.join(",")).join("\n");

//   //   const encodedUri = encodeURI(csvContent);
//   //   const link = document.createElement("a");
//   //   link.setAttribute("href", encodedUri);
//   //   link.setAttribute("download", "payments_data.csv");
//   //   document.body.appendChild(link);

//   //   link.click();
//   //   document.body.removeChild(link);
//   // };

//   const downloadXLSX = () => {
//     const headers = [
//       "Description/Deposite Type",
//       "Building & Unit",
//       "Tenant Name",
//       "Date",
//       "Rent For Month",
//       // "Status",
//       "Payment Note",
//       "Amount",
//     ];

//     const dataForXLSX = [
//       headers,
//       ...data.map((item) => [
//         item.nature.charAt(0) + item.nature.slice(1),
//         item.building_name && item.unit_name
//           ? `(B)-${item.building_name}(U)-${item.unit_name}`
//           : "",
//         item.tenant_name.charAt(0) + item.tenant_name.slice(1),
//         item.local_date,
//         item.month,
//         // item.payment_status === "success" ? "Paid" : "Not Paid",
//         item.description ? item.description : "Not Provided",
//         item.local_amount,
//       ]),
//     ];

//     const workbook = XLSX.utils.book_new();
//     const worksheet = XLSX.utils.aoa_to_sheet(dataForXLSX);

//     // Apply enhanced header styling
//     const headerCellStyle = {
//       font: { bold: true, color: { rgb: "FFFFFF" } }, // Bold white text
//       fill: { fgColor: { rgb: "4F81BD" } }, // Blue background
//       alignment: { horizontal: "center" }, // Center align text
//     };

//     headers.forEach((_, colIndex) => {
//       const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIndex });
//       worksheet[cellAddress] = {
//         ...worksheet[cellAddress],
//         s: headerCellStyle,
//       };

//       // Optionally set column width based on header length (you might need more sophisticated logic)
//       const colWidth = { wch: headers[colIndex].length + 5 }; // Add some padding
//       worksheet["!cols"] = worksheet["!cols"] || [];
//       worksheet["!cols"][colIndex] = colWidth;
//     });

//     XLSX.utils.book_append_sheet(workbook, worksheet, "Payments Data");
//     XLSX.writeFile(workbook, "payments_data.xlsx");
//   };

//   const paymentDetailsModal = (item) => {
//     // console.log("Row clicked:", item); // Add a console log here
//     setSelectedPayment(item); // Store the selected payment details
//     setShowPaymentModal(true); // Show the modal
//   };

//   const calculateSerialNumber = (monthIndex, index) => {
//     const previousMonthsData = Object.keys(groupedData)
//       .slice(0, monthIndex)
//       .reduce((acc, month) => acc + groupedData[month].length, 0);
//     return previousMonthsData + index + 1;
//   };

//   // Prepare the columns and rows for the GenericTable
//   const columns = [
//     { id: "serialNo", label: "Record No." },
//     { id: "nature", label: "Deposit Type" },
//     { id: "buildingUnit", label: "Building & Unit" },
//     { id: "tenant", label: "Tenant Details" },
//     { id: "date", label: "Date" },
//     { id: "rentMonth", label: "Rent For Month" },
//     // { id: "status", label: "Status" },
//     { id: "paymentNote", label: "PaymentNote" },
//     { id: "amount", label: "Amount" },
//   ];

//   const rows = Object.keys(groupedData).flatMap((month, monthIndex) =>
//     groupedData[month].map((item, index) => ({
//       serialNo: calculateSerialNumber(monthIndex, index),
//       nature: item.nature,
//       buildingUnit: `(B)-${item.building_name}(U)-${item.unit_name}`,
//       tenant: item.tenant_name,
//       date: item.local_date,
//       rentMonth: item.month,
//       // status: item.payment_status === "success" ? "Paid" : "Not Paid",
//       paymentNote: item.description ? item.description : "Not Provided",
//       amount: item.amount,
//       onClick: () => {
//         console.log("Row clicked:", item); // Log to verify onClick
//         paymentDetailsModal(item);
//       }, // Add a log here to see if it fires
//     }))
//   );

//   return (
//     // <div className="flex flex-col item-start">
//     <div className="table-container" style={{ marginBottom: "20px" }}>
//       <button
//         style={{
//           padding: "10px",
//           backgroundColor: "green",
//           marginBottom: "20px",
//           color: "white",
//           borderRadius: "10px",
//           float: "right",
//         }}
//         // onClick={downloadCSV}
//         onClick={downloadXLSX}
//       >
//         Download Displayed Record
//       </button>
//       {/* <button
//         style={{
//           fontSize: 10,
//           maxWidth: 150,
//           padding: "5px",
//           backgroundColor: "green",
//           // marginBottom: "20px",
//           color: "white",
//           borderRadius: "10px",
//         }}
//         onClick={downloadCSV}
//       >
//         Download Displayed Record
//       </button> */}

//       {/* Use the GenericTable here */}
//       {/* <GenericTable
//         columns={columns}
//         rows={rows}
//         rowsPerPageOptions={[10, 25, 50, 100]}
//         tableHeight={450}
//         loading={loading} // Pass loading state
//         loaderAnimation={loaderAnimation} // Pass the loader animation JSON
//       /> */}

//       {/* <PaymentModal
//         isVisible={showPaymentModal}
//         onClose={() => setShowPaymentModal(false)}
//         paymentDetails={selectedPayment}
//       /> */}

//       {/* {loading && (
//         <div style={{ textAlign: "center", padding: "20px" }}>
//           <Lottie animationData={loaderAnimation} loop={true} />
//         </div>
//       )} */}
//       <table
//         style={{ width: "100%", borderCollapse: "collapse" }}
//         className="bg-white border border-gray-200"
//       >
//         <thead
//           style={
//             {
//               // position: "sticky",
//               // top: "0",
//               // zIndex: "1",
//               // backgroundColor: "#fff",
//             }
//           }
//           className="text-xs bg-gray-100"
//         >
//           <tr>
//             <th style={tableHeaderStyle}>Record No.</th>
//             <th style={tableHeaderStyle}>Deposit Type</th>
//             <th style={tableHeaderStyle}>Building & Unit</th>
//             <th style={tableHeaderStyle}>Tenant Details</th>
//             <th style={tableHeaderStyle}>Date</th>
//             <th style={tableHeaderStyle}>Rent For Month</th>
//             {/* <th style={tableHeaderStyle}>Status</th> */}
//             <th style={tableHeaderStyle}>Payment Note</th>
//             <th style={tableHeaderStyle}>Amount</th>
//             <th style={tableHeaderStyle}></th>
//           </tr>
//         </thead>
//         <tbody>
//           {Object.keys(groupedData).map((month, monthIndex) => (
//             <React.Fragment key={month}>
//               {groupedData[month].map((innerItem, index) => (
//                 <tr
//                   key={index}
//                   style={tableRowStyle}
//                   className="text-xs hover:bg-gray-50 cursor-pointer"
//                   onClick={() => paymentDetailsModal(innerItem)} // Trigger modal
//                 >
//                   <td style={tableCellStyle}>
//                     {calculateSerialNumber(monthIndex, index)}
//                   </td>
//                   <td style={tableCellStyle}>
//                     {innerItem.nature ? innerItem.nature.toUpperCase() : ""}
//                   </td>
//                   <td style={tableCellStyle}>
//                     {innerItem.building_name && innerItem.unit_name
//                       ? `(B)-${innerItem.building_name.toUpperCase()}(U)-${innerItem.unit_name.toUpperCase()}`
//                       : ""}
//                   </td>
//                   <td style={tableCellStyle}>{innerItem.tenant_name}</td>
//                   <td style={tableCellStyle}>{innerItem.local_date}</td>
//                   <td style={tableCellStyle}>{innerItem.month}</td>
//                   <td style={tableCellStyle}>
//                     {/* {innerItem.payment_status === "success"
//                       ? "Paid"
//                       : "Not Paid"} */}
//                     {innerItem.description
//                       ? innerItem.description
//                       : "Not Provided"}
//                   </td>
//                   <td style={tableCellStyle}>{innerItem.amount}</td>
//                   <td>
//                     {/* Delete button for a payment */}
//                     {innerItem.payment_id === "manual" ? (
//                       <MdDeleteForever
//                         size={20}
//                         color="red"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           handleDelete(
//                             innerItem.entity_id,
//                             innerItem.month,
//                             innerItem.year,
//                             innerItem.is_check || false // Use the actual `is_check` field if available
//                           );
//                         }}
//                         style={{ cursor: "pointer" }}
//                       />
//                     ) : null}
//                   </td>
//                 </tr>
//               ))}
//               <PaymentModal
//                 isVisible={showPaymentModal}
//                 onClose={() => setShowPaymentModal(false)}
//                 paymentDetails={selectedPayment}
//                 deleteRecord={handleDelete}
//               />
//             </React.Fragment>
//           ))}
//           {/* {loading && (
//             <tr>
//               <td colSpan="7" style={{ textAlign: "center" }}>
//                 <Lottie
//                   animationData={loaderAnimation}
//                   loop={true}
//                   style={{ width: 150, height: 150 }}
//                 />
//               </td>
//             </tr>
//           )} */}
//           {loading && (
//             <tr>
//               <td colSpan="9" className="py-8 text-center">
//                 {/* MODIFIED: Use text-center on td */}
//                 <Lottie
//                   animationData={loaderAnimation}
//                   loop={true}
//                   className="w-20 h-20 inline-block"
//                 />
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </table>

//       {nextPageToken === "END" && (
//         <p className="text-center p-4">******END OF PAYMENTS DATA******</p>
//       )}

//       {displayAll && (
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             marginTop: "20px",
//           }}
//         >
//           <button
//             onClick={handleNext}
//             disabled={!nextPageToken || nextPageToken === "END" || loading}
//             style={{
//               padding: "10px 30px",
//               backgroundColor: nextPageToken === "END" ? "gray" : "blue",
//               color: "white",
//               borderRadius: "10px",
//               cursor: nextPageToken === "END" ? "not-allowed" : "pointer",
//             }}
//           >
//             Show More
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// const tableHeaderStyle = {
//   backgroundColor: "#F5F7FA",
//   padding: "10px",
//   borderBottom: "1px solid #E1E8F0",
//   textAlign: "left",
// };

// const tableRowStyle = {
//   borderBottom: "1px solid #E1E8F0",
// };

// const tableCellStyle = {
//   padding: "10px",
//   textAlign: "left",
// };

// const buttonStyle = {
//   padding: "10px 30px",
//   backgroundColor: "blue",
//   color: "white",
//   cursor: "pointer",
//   borderRadius: "10px",
// };

// const disabledButtonStyle = {
//   padding: "10px 30px",
//   borderRadius: "10px",
//   backgroundColor: "gray",
//   color: "white",
//   cursor: "not-allowed",
// };

// export default CustomComponent;

// import React, { useState, useEffect } from "react";
// import APICall from "../../Utility/APICall";
// import { paths } from "../../Utility/Constants";
// import { useAuth } from "../../Utility/AuthProvider";
// import PaymentModal from "../Modals/PaymenModal";
// import { MdDeleteForever } from "react-icons/md";
// import * as XLSX from "xlsx";
// import Lottie from "lottie-react";
// import loaderAnimation from "../../assets/animations/loader.json";

// const CustomComponent = ({ displayAll, hideLoader = false }) => {
//   const { jwt } = useAuth();
//   const [data, setData] = useState([]);
//   const [groupedData, setGroupedData] = useState({});
//   const [nextPageToken, setNextPageToken] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [showPaymentModal, setShowPaymentModal] = useState(false);
//   const [selectedPayment, setSelectedPayment] = useState(null);
//   const [initialLoadComplete, setInitialLoadComplete] = useState(false);

//   const fetchData = async (pageToken) => {
//     try {
//       if (nextPageToken === "END") return;
//       setLoading(true);
//       const response = await APICall(
//         "POST",
//         paths.payments.fetch,
//         { next_page_token: pageToken ?? "" },
//         undefined,
//         jwt
//       );

//       let newPayments = response.response.payments;
//       if (!displayAll) {
//         newPayments = newPayments.slice(0, 5);
//       }

//       const updatedData = [...data, ...newPayments];

//       setData(updatedData);
//       setGroupedData(groupByMonth(updatedData));
//       setNextPageToken(response.response.next_page_token);
//       setLoading(false);
//       setInitialLoadComplete(true);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       setLoading(false);
//       setInitialLoadComplete(true);
//     }
//   };

//   const groupByMonth = (data) => {
//     return data.reduce((acc, item) => {
//       const month = new Date(item.local_date).toLocaleString("default", {
//         month: "long",
//         year: "numeric",
//       });
//       if (!acc[month]) {
//         acc[month] = [];
//       }
//       acc[month].push(item);
//       return acc;
//     }, {});
//   };

//   useEffect(() => {
//     fetchData(null);
//   }, [jwt]);

//   const handleNext = () => {
//     if (nextPageToken && nextPageToken !== "END") {
//       fetchData(nextPageToken);
//     }
//   };

//   const handleDelete = async (transaction_id, month, year, isCheck) => {
//     try {
//       console.log("Entity ID to delete:", transaction_id);

//       const queryParams = new URLSearchParams({
//         transaction_id: transaction_id,
//         month: month,
//         year: year,
//         is_check: isCheck,
//       }).toString();

//       const urlWithParams = `${paths.payments.delete}?${queryParams}`;
//       console.log("API Request URL: ", urlWithParams);

//       const response = await APICall(
//         "DELETE",
//         urlWithParams,
//         undefined,
//         undefined,
//         jwt
//       );

//       console.log("API Response:", response);

//       if (response.status) {
//         const updatedData = data.filter(
//           (item) => item.entity_id !== transaction_id
//         );

//         setData(updatedData);
//         setGroupedData(groupByMonth(updatedData));

//         console.log("Deleted successfully. Updated data:", updatedData);
//       } else {
//         console.error("Failed to delete:", response.error);
//       }
//     } catch (error) {
//       console.error("Error during delete operation:", error);
//     }
//   };

//   const downloadXLSX = () => {
//     const headers = [
//       "Description/Deposite Type",
//       "Building & Unit",
//       "Tenant Name",
//       "Date",
//       "Rent For Month",
//       "Payment Note",
//       "Amount",
//     ];

//     const dataForXLSX = [
//       headers,
//       ...data.map((item) => [
//         item.nature.charAt(0) + item.nature.slice(1),
//         item.building_name && item.unit_name
//           ? `(B)-${item.building_name}(U)-${item.unit_name}`
//           : "",
//         item.tenant_name.charAt(0) + item.tenant_name.slice(1),
//         item.local_date,
//         item.month,
//         item.description ? item.description : "Not Provided",
//         item.local_amount,
//       ]),
//     ];

//     const workbook = XLSX.utils.book_new();
//     const worksheet = XLSX.utils.aoa_to_sheet(dataForXLSX);

//     const headerCellStyle = {
//       font: { bold: true, color: { rgb: "FFFFFF" } },
//       fill: { fgColor: { rgb: "4F81BD" } },
//       alignment: { horizontal: "center" },
//     };

//     headers.forEach((_, colIndex) => {
//       const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIndex });
//       worksheet[cellAddress] = {
//         ...worksheet[cellAddress],
//         s: headerCellStyle,
//       };

//       const colWidth = { wch: headers[colIndex].length + 5 };
//       worksheet["!cols"] = worksheet["!cols"] || [];
//       worksheet["!cols"][colIndex] = colWidth;
//     });

//     XLSX.utils.book_append_sheet(workbook, worksheet, "Payments Data");
//     XLSX.writeFile(workbook, "payments_data.xlsx");
//   };

//   const paymentDetailsModal = (item) => {
//     setSelectedPayment(item);
//     setShowPaymentModal(true);
//   };

//   const calculateSerialNumber = (monthIndex, index) => {
//     const previousMonthsData = Object.keys(groupedData)
//       .slice(0, monthIndex)
//       .reduce((acc, month) => acc + groupedData[month].length, 0);
//     return previousMonthsData + index + 1;
//   };

//   // For initial load on Dashboard, don't show loader
//   if (loading && !initialLoadComplete && !displayAll) {
//     return null; // Return null instead of showing loader
//   }

//   return (
//     <div className="table-container" style={{ marginBottom: "20px" }}>
//       <button
//         style={{
//           padding: "10px",
//           backgroundColor: "green",
//           marginBottom: "20px",
//           color: "white",
//           borderRadius: "10px",
//           float: "right",
//         }}
//         onClick={downloadXLSX}
//       >
//         Download Displayed Record
//       </button>

//       <table
//         style={{ width: "100%", borderCollapse: "collapse" }}
//         className="bg-white border border-gray-200"
//       >
//         <thead className="text-xs bg-gray-100">
//           <tr>
//             <th style={tableHeaderStyle}>Record No.</th>
//             <th style={tableHeaderStyle}>Deposit Type</th>
//             <th style={tableHeaderStyle}>Building & Unit</th>
//             <th style={tableHeaderStyle}>Tenant Details</th>
//             <th style={tableHeaderStyle}>Date</th>
//             <th style={tableHeaderStyle}>Rent For Month</th>
//             <th style={tableHeaderStyle}>Payment Note</th>
//             <th style={tableHeaderStyle}>Amount</th>
//             <th style={tableHeaderStyle}></th>
//           </tr>
//         </thead>
//         <tbody>
//           {Object.keys(groupedData).map((month, monthIndex) => (
//             <React.Fragment key={month}>
//               {groupedData[month].map((innerItem, index) => (
//                 <tr
//                   key={index}
//                   style={tableRowStyle}
//                   className="text-xs hover:bg-gray-50 cursor-pointer"
//                   onClick={() => paymentDetailsModal(innerItem)}
//                 >
//                   <td style={tableCellStyle}>
//                     {calculateSerialNumber(monthIndex, index)}
//                   </td>
//                   <td style={tableCellStyle}>
//                     {innerItem.nature ? innerItem.nature.toUpperCase() : ""}
//                   </td>
//                   <td style={tableCellStyle}>
//                     {innerItem.building_name && innerItem.unit_name
//                       ? `(B)-${innerItem.building_name.toUpperCase()}(U)-${innerItem.unit_name.toUpperCase()}`
//                       : ""}
//                   </td>
//                   <td style={tableCellStyle}>{innerItem.tenant_name}</td>
//                   <td style={tableCellStyle}>{innerItem.local_date}</td>
//                   <td style={tableCellStyle}>{innerItem.month}</td>
//                   <td style={tableCellStyle}>
//                     {innerItem.description
//                       ? innerItem.description
//                       : "Not Provided"}
//                   </td>
//                   <td style={tableCellStyle}>{innerItem.amount}</td>
//                   <td>
//                     {innerItem.payment_id === "manual" ? (
//                       <MdDeleteForever
//                         size={20}
//                         color="red"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           handleDelete(
//                             innerItem.entity_id,
//                             innerItem.month,
//                             innerItem.year,
//                             innerItem.is_check || false
//                           );
//                         }}
//                         style={{ cursor: "pointer" }}
//                       />
//                     ) : null}
//                   </td>
//                 </tr>
//               ))}
//               <PaymentModal
//                 isVisible={showPaymentModal}
//                 onClose={() => setShowPaymentModal(false)}
//                 paymentDetails={selectedPayment}
//                 deleteRecord={handleDelete}
//               />
//             </React.Fragment>
//           ))}
//           {/* Only show loader for "Show More" action or on displayAll pages */}
//           {loading && displayAll && (
//             <tr>
//               <td colSpan="9" className="py-8 text-center">
//                 <Lottie
//                   animationData={loaderAnimation}
//                   loop={true}
//                   className="w-20 h-20 inline-block"
//                 />
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </table>

//       {nextPageToken === "END" && (
//         <p className="text-center p-4">******END OF PAYMENTS DATA******</p>
//       )}

//       {displayAll && (
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             marginTop: "20px",
//           }}
//         >
//           <button
//             onClick={handleNext}
//             disabled={!nextPageToken || nextPageToken === "END" || loading}
//             style={{
//               padding: "10px 30px",
//               backgroundColor: nextPageToken === "END" ? "gray" : "blue",
//               color: "white",
//               borderRadius: "10px",
//               cursor: nextPageToken === "END" ? "not-allowed" : "pointer",
//             }}
//           >
//             Show More
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// const tableHeaderStyle = {
//   backgroundColor: "#F5F7FA",
//   padding: "10px",
//   borderBottom: "1px solid #E1E8F0",
//   textAlign: "left",
// };

// const tableRowStyle = {
//   borderBottom: "1px solid #E1E8F0",
// };

// const tableCellStyle = {
//   padding: "10px",
//   textAlign: "left",
// };

// export default CustomComponent;

// import React, { useEffect, useState } from "react";
// import { usePayments } from "../../Contexts/PaymentsContext";
// import PaymentModal from "../Modals/PaymenModal";
// // import { MdDeleteForever } from "react-icons/md";
// import { AiOutlineDelete } from "react-icons/ai";
// import * as XLSX from "xlsx";
// import Lottie from "lottie-react";
// import loaderAnimation from "../../assets/animations/loader.json";

// const CustomComponent = ({
//   displayAll = false,
//   showDownloadButton = true,
//   limitRows = false,
// }) => {
//   const {
//     payments,
//     groupedPayments,
//     isLoading,
//     nextPageToken,
//     hasInitiallyLoaded,
//     fetchPayments,
//     deletePayment,
//   } = usePayments();

//   const [showPaymentModal, setShowPaymentModal] = useState(false);
//   const [selectedPayment, setSelectedPayment] = useState(null);

//   // Fetch all data when on Payments page
//   useEffect(() => {
//     if (displayAll && hasInitiallyLoaded && nextPageToken !== "END") {
//       fetchPayments({ fetchAll: true });
//     }
//   }, [displayAll, hasInitiallyLoaded, nextPageToken, fetchPayments]);

//   const handleNext = () => {
//     if (nextPageToken && nextPageToken !== "END") {
//       fetchPayments({ pageToken: nextPageToken });
//     }
//   };

//   const handleDelete = async (transaction_id, month, year, isCheck) => {
//     const success = await deletePayment(transaction_id, month, year, isCheck);
//     if (!success) {
//       console.error("Failed to delete payment");
//     }
//   };

//   const downloadXLSX = () => {
//     const headers = [
//       "Deposit Type",
//       "Building & Unit",
//       "Tenant Details",
//       "Date",
//       "Rent For Month",
//       "Note",
//       "Amount",
//     ];

//     const dataForXLSX = [
//       headers,
//       ...payments.map((item) => [
//         item.nature.charAt(0).toUpperCase() + item.nature.slice(1),
//         item.building_name && item.unit_name
//           ? `${item.building_name} - ${item.unit_name}`
//           : "",
//         item.tenant_name,
//         item.local_date,
//         item.month,
//         item.description || "NA",
//         item.local_amount,
//       ]),
//     ];

//     const workbook = XLSX.utils.book_new();
//     const worksheet = XLSX.utils.aoa_to_sheet(dataForXLSX);

//     // Add column widths
//     worksheet["!cols"] = headers.map((header) => ({ wch: header.length + 8 }));

//     XLSX.utils.book_append_sheet(workbook, worksheet, "Payments Data");
//     XLSX.writeFile(workbook, "payments_data.xlsx");
//   };

//   const paymentDetailsModal = (item) => {
//     setSelectedPayment(item);
//     setShowPaymentModal(true);
//   };

//   // Get display data based on limitRows prop
//   const getDisplayData = () => {
//     if (!limitRows) return groupedPayments;

//     // For Dashboard, show only first 5 records
//     const limited = {};
//     let count = 0;

//     for (const [month, items] of Object.entries(groupedPayments)) {
//       limited[month] = [];
//       for (const item of items) {
//         if (count >= 5) break;
//         limited[month].push(item);
//         count++;
//       }
//       if (count >= 5) break;
//     }

//     return limited;
//   };

//   const displayData = getDisplayData();

//   // Don't show loader on Dashboard
//   if (isLoading && !hasInitiallyLoaded && !displayAll) {
//     return null;
//   }

//   // Show loader only on Payments page during initial load
//   if (isLoading && !hasInitiallyLoaded && displayAll) {
//     return (
//       <div className="flex justify-center items-center py-20">
//         <Lottie
//           animationData={loaderAnimation}
//           loop={true}
//           style={{ width: 100, height: 100 }}
//         />
//       </div>
//     );
//   }

//   return (
//     <div className="w-full">
//       {showDownloadButton && (
//         <div className="flex justify-end mb-5">
//           <button
//             onClick={downloadXLSX}
//             className="px-5 py-2.5 bg-green-600 text-white text-sm font-medium rounded-lg hover:bg-green-700 transition-colors"
//           >
//             Download Displayed Record
//           </button>
//         </div>
//       )}

//       <div className="overflow-x-auto">
//         <table className="w-full overflow-clip">
//           <thead>
//             <tr className="border-b border-gray-100">
//               {displayAll && (
//                 <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
//                   Sr No.
//                 </th>
//               )}
//               <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
//                 {displayAll ? "Deposit Type" : "Description"}
//               </th>
//               {displayAll && (
//                 <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
//                   Building & Unit
//                 </th>
//               )}
//               <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
//                 Tenant
//               </th>
//               <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
//                 Date
//               </th>
//               {displayAll && (
//                 <>
//                   <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
//                     Rent For Month
//                   </th>
//                   <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
//                     Status
//                   </th>
//                 </>
//               )}
//               {!displayAll && (
//                 <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
//                   Status
//                 </th>
//               )}
//               <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
//                 Amount
//               </th>
//               {displayAll && (
//                 <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
//                   Note
//                 </th>
//               )}
//               {displayAll && (
//                 <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
//                   Actions
//                 </th>
//               )}
//             </tr>
//           </thead>
//           <tbody className="border-b-0 border-gray-200 border-1">
//             {(() => {
//               let recordNo = 0;
//               return Object.keys(displayData).map((month) => (
//                 <React.Fragment key={month}>
//                   {displayData[month].map((item, index) => {
//                     recordNo++;
//                     // Splitting date and time for better formatting
//                     const [date, time] = item.local_date
//                       ? item.local_date.split(", ")
//                       : ["", ""];

//                     return (
//                       <tr
//                         key={`${month}-${index}`}
//                         className="border-b border-gray-50 hover:bg-gray-50 cursor-pointer transition-colors"
//                         onClick={() => paymentDetailsModal(item)}
//                       >
//                         {displayAll && (
//                           <td className="py-3 px-2 text-xs text-nowrap text-gray-900">
//                             {recordNo}
//                           </td>
//                         )}
//                         <td className="py-3 px-2">
//                           {displayAll ? (
//                             <span className="text-xs text-nowrap text-gray-900 uppercase">
//                               {item.nature || "SECURITY_DEPOSIT"}
//                             </span>
//                           ) : (
//                             // Improved layout for the dashboard's description
//                             <div className="flex flex-col">
//                               <span className="font-medium text-xs text-nowrap text-gray-900">
//                                 {item.month} Rent
//                               </span>
//                               <span className="text-xs text-gray-500">
//                                 {item.nature
//                                   ? item.nature.charAt(0).toUpperCase() +
//                                     item.nature.slice(1)
//                                   : ""}
//                               </span>
//                             </div>
//                           )}
//                         </td>
//                         {displayAll && (
//                           <td className="py-3 px-2 text-xs text-gray-900">
//                             {item.building_name && item.unit_name ? (
//                               <div className="flex flex-col">
//                                 {" "}
//                                 {/* Added flex flex-col here */}
//                                 <span className="text-nowrap">
//                                   (B)-{item.building_name.toUpperCase()}
//                                 </span>
//                                 <span className="text-nowrap">
//                                   (U)-{item.unit_name.toUpperCase()}
//                                 </span>
//                               </div>
//                             ) : (
//                               ""
//                             )}
//                           </td>
//                         )}
//                         <td className="py-3 px-2">
//                           {/* FIX: Using a flex container to stack Tenant Name and Building/Unit */}
//                           <div className="flex flex-col">
//                             <span className="text-xs text-nowrap font-medium text-gray-900">
//                               {item.tenant_name}
//                             </span>
//                             {!displayAll && (
//                               <span className="text-xs text-nowrap text-gray-500">
//                                 {item.building_name} - {item.unit_name}
//                               </span>
//                             )}
//                           </div>
//                         </td>
//                         <td className="py-3 px-2 text-xs text-nowrap text-gray-900">
//                           {/* FIX: Displaying Date and Time on separate lines for clarity */}
//                           <div className="flex flex-col">
//                             <span>{date}</span>
//                             <span className="text-xs text-gray-500">
//                               {time}
//                             </span>
//                           </div>
//                         </td>
//                         {displayAll && (
//                           <>
//                             <td className="py-3 px-2 text-xs text-nowrap text-gray-900">
//                               {item.month}
//                             </td>
//                             <td className="py-3 px-4">
//                               <span className="text-xs text-nowrap font-medium text-green-600">
//                                 Paid
//                               </span>
//                             </td>
//                           </>
//                         )}
//                         {!displayAll && (
//                           <td className="py-3 px-2">
//                             <span
//                               className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs text-nowrap font-medium ${
//                                 item.payment_status === "success"
//                                   ? "bg-green-50 text-green-700 border border-green-200"
//                                   : "bg-red-50 text-red-700 border border-red-200"
//                               }`}
//                             >
//                               <span
//                                 className={`w-1.5 h-1.5 rounded-full mr-1.5 ${
//                                   item.payment_status === "success"
//                                     ? "bg-green-500"
//                                     : "bg-red-500"
//                                 }`}
//                               ></span>
//                               {item.payment_status === "success"
//                                 ? "Paid"
//                                 : "Failed"}
//                             </span>
//                           </td>
//                         )}
//                         <td className="py-3 px-2 text-xs text-nowrap font-medium text-gray-900 text-left">
//                           {/* FIX: Added currency symbol for consistency */}
//                           {item.local_amount
//                             ? item.local_amount.toLocaleString()
//                             : item.amount}
//                         </td>
//                         {displayAll && (
//                           <>
//                             <td className="py-3 px-2 text-xs text-nowrap text-gray-900">
//                               {item.description || "NA"}
//                             </td>
//                             <td
//                               className="py-3 px-2"
//                               onClick={(e) => e.stopPropagation()}
//                             >
//                               {item.payment_id === "manual" && (
//                                 <AiOutlineDelete
//                                   size={20}
//                                   color="#EF4444"
//                                   onClick={() =>
//                                     handleDelete(
//                                       item.entity_id,
//                                       item.month,
//                                       item.year,
//                                       item.is_check || false
//                                     )
//                                   }
//                                   className="cursor-pointer hover:opacity-80"
//                                 />
//                               )}
//                             </td>
//                           </>
//                         )}
//                       </tr>
//                     );
//                   })}
//                 </React.Fragment>
//               ));
//             })()}
//           </tbody>
//         </table>
//       </div>

//       {!limitRows && nextPageToken === "END" && (
//         <p className="text-center text-gray-400 text-sm py-6 mt-6">
//           ******END OF PAYMENTS DATA******
//         </p>
//       )}

//       {!limitRows && displayAll && nextPageToken && nextPageToken !== "END" && (
//         <div className="flex justify-start mt-6">
//           <button
//             onClick={handleNext}
//             disabled={isLoading}
//             className={`px-8 py-2.5 rounded-lg font-medium text-white transition-colors ${
//               isLoading
//                 ? "bg-gray-400 cursor-not-allowed"
//                 : "bg-blue-600 hover:bg-blue-700"
//             }`}
//           >
//             {isLoading ? "Loading..." : "Show More"}
//           </button>
//         </div>
//       )}

//       <PaymentModal
//         isVisible={showPaymentModal}
//         onClose={() => setShowPaymentModal(false)}
//         paymentDetails={selectedPayment}
//         deleteRecord={handleDelete}
//       />
//     </div>
//   );
// };

// export default CustomComponent;

// import React, { useEffect, useState } from "react";
// import { usePayments } from "../../Contexts/PaymentsContext";
// import PaymentModal from "../Modals/PaymenModal"; // Assuming this is your detailed payment view modal
// import { AiOutlineDelete } from "react-icons/ai";
// import * as XLSX from "xlsx";
// import Lottie from "lottie-react";
// import loaderAnimation from "../../assets/animations/loader.json";
// import DialogModal from "../Modals/DialogModal"; // Import your reusable DialogModal

// const CustomComponent = ({
//   displayAll = false,
//   showDownloadButton = true,
//   limitRows = false,
// }) => {
//   const {
//     payments,
//     groupedPayments,
//     isLoading,
//     nextPageToken,
//     hasInitiallyLoaded,
//     fetchPayments,
//     deletePayment, // This is the context function to perform the actual deletion
//   } = usePayments();

//   const [showPaymentModal, setShowPaymentModal] = useState(false);
//   const [selectedPayment, setSelectedPayment] = useState(null);

//   // State for delete confirmation modal
//   const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
//   const [paymentToDelete, setPaymentToDelete] = useState(null); // Stores details of the payment selected for deletion

//   // Fetch all data when on Payments page
//   useEffect(() => {
//     if (displayAll && hasInitiallyLoaded && nextPageToken !== "END") {
//       fetchPayments({ fetchAll: true });
//     }
//   }, [displayAll, hasInitiallyLoaded, nextPageToken, fetchPayments]);

//   const handleNext = () => {
//     if (nextPageToken && nextPageToken !== "END") {
//       fetchPayments({ pageToken: nextPageToken });
//     }
//   };

//   // Step 1: This function now just prepares for the modal
//   const handleDeleteClick = (itemDetails) => {
//     setPaymentToDelete(itemDetails); // Store the details
//     setShowDeleteConfirmModal(true); // Show the confirmation modal
//   };

//   // Step 2: This function is called when user confirms deletion in the modal
//   const confirmDeleteAction = async () => {
//     if (paymentToDelete) {
//       const { entity_id, month, year, is_check } = paymentToDelete;
//       // Call the context's deletePayment function
//       const success = await deletePayment(entity_id, month, year, is_check);

//       if (!success) {
//         console.error("Failed to delete payment");
//         // Optionally, show a toast notification for deletion failure
//       } else {
//         console.log("Payment deleted successfully.");
//         // Optionally, show a toast notification for deletion success
//       }
//       // Always close the modal and reset state after action
//       setShowDeleteConfirmModal(false);
//       setPaymentToDelete(null);
//     }
//   };

//   const downloadXLSX = () => {
//     const headers = [
//       "Deposit Type",
//       "Building & Unit",
//       "Tenant Details",
//       "Date",
//       "Rent For Month",
//       "Note",
//       "Amount",
//     ];

//     const dataForXLSX = [
//       headers,
//       ...payments.map((item) => [
//         item.nature.charAt(0).toUpperCase() + item.nature.slice(1),
//         item.building_name && item.unit_name
//           ? `${item.building_name} - ${item.unit_name}`
//           : "",
//         item.tenant_name,
//         item.local_date,
//         item.month,
//         item.description || "NA",
//         item.local_amount,
//       ]),
//     ];

//     const workbook = XLSX.utils.book_new();
//     const worksheet = XLSX.utils.aoa_to_sheet(dataForXLSX);

//     // Add column widths
//     worksheet["!cols"] = headers.map((header) => ({ wch: header.length + 8 }));

//     XLSX.utils.book_append_sheet(workbook, worksheet, "Payments Data");
//     XLSX.writeFile(workbook, "payments_data.xlsx");
//   };

//   const paymentDetailsModal = (item) => {
//     setSelectedPayment(item);
//     setShowPaymentModal(true);
//   };

//   // Get display data based on limitRows prop
//   const getDisplayData = () => {
//     if (!limitRows) return groupedPayments;

//     // For Dashboard, show only first 5 records
//     const limited = {};
//     let count = 0;

//     for (const [month, items] of Object.entries(groupedPayments)) {
//       limited[month] = [];
//       for (const item of items) {
//         if (count >= 5) break;
//         limited[month].push(item);
//         count++;
//       }
//       if (count >= 5) break;
//     }

//     return limited;
//   };

//   const displayData = getDisplayData();

//   // Don't show loader on Dashboard
//   if (isLoading && !hasInitiallyLoaded && !displayAll) {
//     return null;
//   }

//   // Show loader only on Payments page during initial load
//   if (isLoading && !hasInitiallyLoaded && displayAll) {
//     return (
//       <div className="flex justify-center items-center py-20">
//         <Lottie
//           animationData={loaderAnimation}
//           loop={true}
//           style={{ width: 100, height: 100 }}
//         />
//       </div>
//     );
//   }

//   return (
//     <div className="w-full">
//       {showDownloadButton && (
//         <div className="flex justify-end mb-5">
//           <button
//             onClick={downloadXLSX}
//             className="px-5 py-2.5 bg-green-600 text-white text-sm font-medium rounded-lg hover:bg-green-700 transition-colors"
//           >
//             Download Displayed Record
//           </button>
//         </div>
//       )}

//       <div className="overflow-x-auto">
//         <table className="w-full overflow-clip">
//           <thead>
//             <tr className="border-b border-gray-100">
//               {displayAll && (
//                 <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
//                   Sr No.
//                 </th>
//               )}
//               <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
//                 {displayAll ? "Deposit Type" : "Description"}
//               </th>
//               {displayAll && (
//                 <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
//                   Building & Unit
//                 </th>
//               )}
//               <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
//                 Tenant
//               </th>
//               <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
//                 Date
//               </th>
//               {displayAll && (
//                 <>
//                   <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
//                     Rent For Month
//                   </th>
//                   <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
//                     Status
//                   </th>
//                 </>
//               )}
//               {!displayAll && (
//                 <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
//                   Status
//                 </th>
//               )}
//               <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
//                 Amount
//               </th>
//               {displayAll && (
//                 <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
//                   Note
//                 </th>
//               )}
//               {displayAll && (
//                 <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
//                   Actions
//                 </th>
//               )}
//             </tr>
//           </thead>
//           <tbody className="border-b-0 border-gray-200 border-1">
//             {(() => {
//               let recordNo = 0;
//               return Object.keys(displayData).map((month) => (
//                 <React.Fragment key={month}>
//                   {displayData[month].map((item, index) => {
//                     recordNo++;
//                     const [date, time] = item.local_date
//                       ? item.local_date.split(", ")
//                       : ["", ""];

//                     return (
//                       <tr
//                         key={`${month}-${index}`}
//                         className="border-b border-gray-50 hover:bg-gray-50 cursor-pointer transition-colors"
//                         onClick={() => paymentDetailsModal(item)}
//                       >
//                         {displayAll && (
//                           <td className="py-3 px-2 text-xs text-nowrap text-gray-900">
//                             {recordNo}
//                           </td>
//                         )}
//                         <td className="py-3 px-2">
//                           {displayAll ? (
//                             <span className="text-xs text-nowrap text-gray-900 uppercase">
//                               {item.nature || "SECURITY_DEPOSIT"}
//                             </span>
//                           ) : (
//                             <div className="flex flex-col">
//                               <span className="font-medium text-xs text-nowrap text-gray-900">
//                                 {item.month} Rent
//                               </span>
//                               <span className="text-xs text-gray-500">
//                                 {item.nature
//                                   ? item.nature.charAt(0).toUpperCase() +
//                                     item.nature.slice(1)
//                                   : ""}
//                               </span>
//                             </div>
//                           )}
//                         </td>
//                         {displayAll && (
//                           <td className="py-3 px-2 text-xs text-gray-900">
//                             {item.building_name && item.unit_name ? (
//                               <div className="flex flex-col">
//                                 <span className="text-nowrap">
//                                   (B)-{item.building_name.toUpperCase()}
//                                 </span>
//                                 <span className="text-nowrap">
//                                   (U)-{item.unit_name.toUpperCase()}
//                                 </span>
//                               </div>
//                             ) : (
//                               ""
//                             )}
//                           </td>
//                         )}
//                         <td className="py-3 px-2">
//                           <div className="flex flex-col">
//                             <span className="text-xs text-nowrap font-medium text-gray-900">
//                               {item.tenant_name}
//                             </span>
//                             {!displayAll && (
//                               <span className="text-xs text-nowrap text-gray-500">
//                                 {item.building_name} - {item.unit_name}
//                               </span>
//                             )}
//                           </div>
//                         </td>
//                         <td className="py-3 px-2 text-xs text-nowrap text-gray-900">
//                           <div className="flex flex-col">
//                             <span>{date}</span>
//                             <span className="text-xs text-gray-500">
//                               {time}
//                             </span>
//                           </div>
//                         </td>
//                         {displayAll && (
//                           <>
//                             <td className="py-3 px-2 text-xs text-nowrap text-gray-900">
//                               {item.month}
//                             </td>
//                             <td className="py-3 px-4">
//                               <span className="text-xs text-nowrap font-medium text-green-600">
//                                 Paid
//                               </span>
//                             </td>
//                           </>
//                         )}
//                         {!displayAll && (
//                           <td className="py-3 px-2">
//                             <span
//                               className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs text-nowrap font-medium ${
//                                 item.payment_status === "success"
//                                   ? "bg-green-50 text-green-700 border border-green-200"
//                                   : "bg-red-50 text-red-700 border border-red-200"
//                               }`}
//                             >
//                               <span
//                                 className={`w-1.5 h-1.5 rounded-full mr-1.5 ${
//                                   item.payment_status === "success"
//                                     ? "bg-green-500"
//                                     : "bg-red-500"
//                                 }`}
//                               ></span>
//                               {item.payment_status === "success"
//                                 ? "Paid"
//                                 : "Failed"}
//                             </span>
//                           </td>
//                         )}
//                         <td className="py-3 px-2 text-xs text-nowrap font-medium text-gray-900 text-left">
//                           {item.local_amount
//                             ? item.local_amount.toLocaleString()
//                             : item.amount}
//                         </td>
//                         {displayAll && (
//                           <>
//                             <td className="py-3 px-2 text-xs text-nowrap text-gray-900">
//                               {item.description || "NA"}
//                             </td>
//                             <td
//                               className="py-3 px-2"
//                               // Prevent row click event from firing when clicking delete icon
//                               onClick={(e) => e.stopPropagation()}
//                             >
//                               {item.payment_id === "manual" && (
//                                 <div className="relative inline-block group">
//                                   <AiOutlineDelete
//                                     size={20}
//                                     color="#EF4444"
//                                     // 🔥 Call the new handler for opening the modal
//                                     onClick={() =>
//                                       handleDeleteClick({
//                                         entity_id: item.entity_id,
//                                         month: item.month,
//                                         year: item.year,
//                                         is_check: item.is_check || false,
//                                       })
//                                     }
//                                     className="cursor-pointer hover:opacity-80 transition-opacity duration-200"
//                                   />
//                                   {/* Tooltip text */}
//                                   <div
//                                     className="
//                                     absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-1
//                                     bg-gray-800 text-white text-xs rounded-md whitespace-nowrap
//                                     opacity-0 invisible group-hover:opacity-100 group-hover:visible
//                                     transition-opacity duration-300 pointer-events-none z-10
//                                     text-wrap
//                                   "
//                                   >
//                                     Deleting will mark payment as not paid.
//                                   </div>
//                                 </div>
//                               )}
//                             </td>
//                           </>
//                         )}
//                       </tr>
//                     );
//                   })}
//                 </React.Fragment>
//               ));
//             })()}
//           </tbody>
//         </table>
//       </div>

//       {!limitRows && nextPageToken === "END" && (
//         <p className="text-center text-gray-400 text-sm py-6 mt-6">
//           ******END OF PAYMENTS DATA******
//         </p>
//       )}

//       {!limitRows && displayAll && nextPageToken && nextPageToken !== "END" && (
//         <div className="flex justify-start mt-6">
//           <button
//             onClick={handleNext}
//             disabled={isLoading}
//             className={`px-8 py-2.5 rounded-lg font-medium text-white transition-colors ${
//               isLoading
//                 ? "bg-gray-400 cursor-not-allowed"
//                 : "bg-blue-600 hover:bg-blue-700"
//             }`}
//           >
//             {isLoading ? "Loading..." : "Show More"}
//           </button>
//         </div>
//       )}

//       {/* Existing Payment Details Modal */}
//       <PaymentModal
//         isVisible={showPaymentModal}
//         onClose={() => setShowPaymentModal(false)}
//         paymentDetails={selectedPayment}
//         // Note: deleteRecord prop here would also ideally use the confirmation modal logic
//         // For simplicity, we're focusing on the table row's delete icon.
//         // If PaymentModal itself has a delete button, you'd apply similar logic there.
//         deleteRecord={handleDeleteClick} // Passing the new handler to PaymentModal
//       />

//       {/* New Delete Confirmation Dialog Modal */}
//       <DialogModal
//         show={showDeleteConfirmModal}
//         onClose={() => {
//           setShowDeleteConfirmModal(false);
//           setPaymentToDelete(null); // Clear stored data on cancel
//         }}
//         title="Confirm Deletion"
//         footerButtons={
//           <>
//             <button
//               onClick={() => {
//                 setShowDeleteConfirmModal(false);
//                 setPaymentToDelete(null);
//               }}
//               className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
//             >
//               Cancel
//             </button>
//             <button
//               onClick={confirmDeleteAction} // This calls the actual delete
//               className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 transition-colors"
//             >
//               Delete
//             </button>
//           </>
//         }
//       >
//         <p className="text-center">
//           Are you sure you want to delete this transaction?
//           <br />
//           <span className="font-semibold text-red-700">
//             This will mark the payment as 'not paid'.
//           </span>
//         </p>
//       </DialogModal>
//     </div>
//   );
// };

// export default CustomComponent;

import React, { useEffect, useState, useMemo, useCallback } from "react";
import { usePayments } from "../../Contexts/PaymentsContext";
import PaymentModal from "../Modals/PaymenModal";
import { AiOutlineDelete } from "react-icons/ai";
import * as XLSX from "xlsx";
import Lottie from "lottie-react";
import loaderAnimation from "../../assets/animations/loader.json";
import DialogModal from "../Modals/DialogModal";
import Filters from "../Common/Filter"; // 1. IMPORTED Filters component

const CustomComponent = ({
  displayAll = false,
  showDownloadButton = true,
  limitRows = false,
}) => {
  // --- CONTEXT & MODAL STATE ---
  const {
    payments, // Using the flat array for filtering
    groupedPayments, // Original grouped data for dashboard
    isLoading,
    nextPageToken,
    hasInitiallyLoaded,
    fetchPayments,
    deletePayment,
  } = usePayments();

  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [paymentToDelete, setPaymentToDelete] = useState(null);

  // --- 2. STATE for search and filters ---
  const [searchQuery, setSearchQuery] = useState("");
  const [activeFilters, setActiveFilters] = useState({
    buildingIds: [],
    unitIds: [],
    tenantIds: [],
  });

  // Fetch all data when on the main Payments page
  useEffect(() => {
    if (displayAll && hasInitiallyLoaded && nextPageToken !== "END") {
      fetchPayments({ fetchAll: true });
    }
  }, [displayAll, hasInitiallyLoaded, nextPageToken, fetchPayments]);

  // --- 3. FILTERING LOGIC ---
  const filteredPayments = useMemo(() => {
    // Only apply filters on the full "Payments" page
    if (!displayAll) {
      return payments;
    }

    let data = [...payments];

    // Apply search query first
    if (searchQuery) {
      const lowercasedQuery = searchQuery.toLowerCase();
      data = data.filter(
        (payment) =>
          payment.tenant_name?.toLowerCase().includes(lowercasedQuery) ||
          payment.building_name?.toLowerCase().includes(lowercasedQuery) ||
          payment.unit_name?.toLowerCase().includes(lowercasedQuery) ||
          payment.month?.toLowerCase().includes(lowercasedQuery) ||
          String(payment.local_amount)?.includes(lowercasedQuery)
      );
    }

    // Apply dropdown filters
    if (activeFilters.buildingIds.length > 0) {
      data = data.filter((payment) =>
        activeFilters.buildingIds.includes(payment.building_id)
      );
    }
    if (activeFilters.unitIds.length > 0) {
      data = data.filter((payment) =>
        activeFilters.unitIds.includes(payment.unit_id)
      );
    }
    if (activeFilters.tenantIds.length > 0) {
      data = data.filter((payment) =>
        activeFilters.tenantIds.includes(payment.tenant_id)
      );
    }

    return data;
  }, [payments, searchQuery, activeFilters, displayAll]);

  // Group the filtered data for rendering
  const filteredGroupedPayments = useMemo(() => {
    return filteredPayments.reduce((acc, item) => {
      const month = new Date(item.local_date).toLocaleString("default", {
        month: "long",
        year: "numeric",
      });
      if (!acc[month]) acc[month] = [];
      acc[month].push(item);
      return acc;
    }, {});
  }, [filteredPayments]);

  // --- 4. FILTER HANDLERS ---
  const handleFilterChange = useCallback((newFiltersFromChild) => {
    setActiveFilters(newFiltersFromChild);
  }, []);

  const handleClearAllFilters = () => {
    setSearchQuery("");
    setActiveFilters({ buildingIds: [], unitIds: [], tenantIds: [] });
  };

  const activeFilterCount = useMemo(() => {
    let count = 0;
    if (searchQuery.trim()) count++;
    count += Object.values(activeFilters).filter(
      (arr) => arr.length > 0
    ).length;
    return count;
  }, [searchQuery, activeFilters]);

  // --- EXISTING HANDLERS ---
  const handleNext = () => {
    if (nextPageToken && nextPageToken !== "END") {
      fetchPayments({ pageToken: nextPageToken });
    }
  };

  const handleDeleteClick = (itemDetails) => {
    setPaymentToDelete(itemDetails);
    setShowDeleteConfirmModal(true);
  };

  const confirmDeleteAction = async () => {
    if (paymentToDelete) {
      const { entity_id, month, year, is_check } = paymentToDelete;
      await deletePayment(entity_id, month, year, is_check);
      setShowDeleteConfirmModal(false);
      setPaymentToDelete(null);
    }
  };

  const downloadXLSX = () => {
    // Use filtered data for download if on the main page
    const dataToDownload = displayAll ? filteredPayments : payments;

    const headers = [
      "Deposit Type",
      "Building & Unit",
      "Tenant Details",
      "Date",
      "Rent For Month",
      "Note",
      "Amount",
    ];
    const dataForXLSX = [
      headers,
      ...dataToDownload.map((item) => [
        item.nature.charAt(0).toUpperCase() + item.nature.slice(1),
        item.building_name && item.unit_name
          ? `${item.building_name} - ${item.unit_name}`
          : "",
        item.tenant_name,
        item.local_date,
        item.month,
        item.description || "NA",
        item.local_amount,
      ]),
    ];

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(dataForXLSX);
    worksheet["!cols"] = headers.map((header) => ({ wch: header.length + 8 }));
    XLSX.utils.book_append_sheet(workbook, worksheet, "Payments Data");
    XLSX.writeFile(workbook, "filtered_payments_data.xlsx");
  };

  const paymentDetailsModal = (item) => {
    setSelectedPayment(item);
    setShowPaymentModal(true);
  };

  const getDisplayData = () => {
    // On main page, use filtered & grouped data. Otherwise, use original logic.
    if (displayAll) return filteredGroupedPayments;

    if (limitRows) {
      const limited = {};
      let count = 0;
      for (const [month, items] of Object.entries(groupedPayments)) {
        limited[month] = [];
        for (const item of items) {
          if (count >= 5) break;
          limited[month].push(item);
          count++;
        }
        if (count >= 5) break;
      }
      return limited;
    }
    return groupedPayments;
  };

  const displayData = getDisplayData();

  if (isLoading && !hasInitiallyLoaded) {
    return (
      <div className="flex justify-center items-center py-20">
        <Lottie
          animationData={loaderAnimation}
          loop={true}
          style={{ width: 100, height: 100 }}
        />
      </div>
    );
  }

  return (
    <div className="w-full">
      {/* 5. CONDITIONAL Filter UI Block */}
      {displayAll && (
        <div className="filters-container bg-gray-50 rounded-lg border p-4 mb-4">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <h3 className="text-lg font-medium">Filters</h3>
              {activeFilterCount > 0 && (
                <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                  {activeFilterCount} active
                </span>
              )}
            </div>
            {activeFilterCount > 0 && (
              <button
                onClick={handleClearAllFilters}
                className="text-sm font-medium text-red-600 hover:text-red-800"
              >
                Clear All
              </button>
            )}
          </div>
          <div className="mb-4">
            <input
              type="text"
              placeholder="Search by tenant, property, month, amount..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
          <Filters
            onFilterChange={handleFilterChange}
            selectedFilters={activeFilters}
            availableFilters={["building", "unit", "tenant"]}
          />
        </div>
      )}

      {showDownloadButton && (
        <div className="flex justify-end mb-5">
          <button
            onClick={downloadXLSX}
            className="px-5 py-2.5 bg-green-600 text-white text-sm font-medium rounded-lg hover:bg-green-700 transition-colors"
          >
            Download Displayed Record
          </button>
        </div>
      )}

      <div className="overflow-x-auto">
        <table className="w-full overflow-clip">
          {/************************************
           *  INCOMPLETE CODE STARTS HERE      *
           ************************************/}
          <thead>
            <tr className="border-b border-gray-100">
              {displayAll && (
                <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
                  Sr No.
                </th>
              )}
              <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
                {displayAll ? "Deposit Type" : "Description"}
              </th>
              {displayAll && (
                <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
                  Building & Unit
                </th>
              )}
              <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
                Tenant
              </th>
              <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
                Date
              </th>
              {displayAll && (
                <>
                  <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
                    Rent For Month
                  </th>
                  <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
                    Status
                  </th>
                </>
              )}
              {!displayAll && (
                <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
                  Status
                </th>
              )}
              <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
                Amount
              </th>
              {displayAll && (
                <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
                  Note
                </th>
              )}
              {displayAll && (
                <th className="text-left text-xs font-normal text-gray-600 py-3 px-2">
                  Actions
                </th>
              )}
            </tr>
          </thead>
          <tbody className="border-b-0 border-gray-200 border-1">
            {Object.keys(displayData).length > 0 ? (
              (() => {
                let recordNo = 0;
                return Object.keys(displayData).map((month) => (
                  <React.Fragment key={month}>
                    {displayData[month].map((item, index) => {
                      recordNo++;
                      const [date, time] = item.local_date
                        ? item.local_date.split(", ")
                        : ["", ""];
                      return (
                        <tr
                          key={`${month}-${index}`}
                          className="border-b border-gray-50 hover:bg-gray-50 cursor-pointer transition-colors"
                          onClick={() => paymentDetailsModal(item)}
                        >
                          {displayAll && (
                            <td className="py-3 px-2 text-xs text-nowrap text-black">
                              {recordNo}
                            </td>
                          )}

                          <td className="py-3 px-2">
                            {displayAll ? (
                              <span className="text-xs text-nowrap text-black uppercase">
                                {item.nature || "SECURITY_DEPOSIT"}
                              </span>
                            ) : (
                              <div className="flex flex-col">
                                <span className="font-medium text-xs text-nowrap text-black">
                                  {item.month} Rent
                                </span>
                                <span className="text-xs text-gray-500">
                                  {item.nature
                                    ? item.nature.charAt(0).toUpperCase() +
                                      item.nature.slice(1)
                                    : ""}
                                </span>
                              </div>
                            )}
                          </td>

                          {displayAll && (
                            <td className="py-3 px-2 text-xs text-black">
                              {item.building_name && item.unit_name ? (
                                <div className="flex flex-col">
                                  <span className="text-nowrap">
                                    (B)-{item.building_name.toUpperCase()}
                                  </span>
                                  <span className="text-nowrap">
                                    (U)-{item.unit_name.toUpperCase()}
                                  </span>
                                </div>
                              ) : (
                                ""
                              )}
                            </td>
                          )}

                          <td className="py-3 px-2">
                            <div className="flex flex-col">
                              <span className="text-xs text-nowrap font-medium text-black">
                                {item.tenant_name}
                              </span>
                              {!displayAll && (
                                <span className="text-xs text-nowrap text-gray-500">
                                  {item.building_name} - {item.unit_name}
                                </span>
                              )}
                            </div>
                          </td>

                          <td className="py-3 px-2 text-xs text-nowrap text-black">
                            <div className="flex flex-col">
                              <span>{date}</span>
                              <span className="text-xs text-gray-500">
                                {time}
                              </span>
                            </div>
                          </td>

                          {displayAll && (
                            <>
                              <td className="py-3 px-2 text-xs text-nowrap text-black">
                                {item.month}
                              </td>
                              <td className="py-3 px-4">
                                <span className="text-xs text-nowrap font-medium text-green-600">
                                  Paid
                                </span>
                              </td>
                            </>
                          )}

                          {!displayAll && (
                            <td className="py-3 px-2">
                              <span
                                className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs text-nowrap font-medium ${item.payment_status === "success" ? "bg-green-50 text-green-700 border border-green-200" : "bg-red-50 text-red-700 border border-red-200"}`}
                              >
                                <span
                                  className={`w-1.5 h-1.5 rounded-full mr-1.5 ${item.payment_status === "success" ? "bg-green-500" : "bg-red-500"}`}
                                ></span>
                                {item.payment_status === "success"
                                  ? "Paid"
                                  : "Failed"}
                              </span>
                            </td>
                          )}

                          <td className="py-3 px-2 text-xs text-nowrap font-medium text-black text-left">
                            {item.local_amount
                              ? item.local_amount.toLocaleString()
                              : item.amount}
                          </td>

                          {displayAll && (
                            <>
                              <td className="py-3 px-2 text-xs text-nowrap text-black">
                                {item.description || "NA"}
                              </td>
                              <td
                                className="py-3 px-2"
                                onClick={(e) => e.stopPropagation()}
                              >
                                {item.payment_id === "manual" && (
                                  <div className="relative inline-block group">
                                    <AiOutlineDelete
                                      size={20}
                                      color="#EF4444"
                                      onClick={() =>
                                        handleDeleteClick({
                                          entity_id: item.entity_id,
                                          month: item.month,
                                          year: item.year,
                                          is_check: item.is_check || false,
                                        })
                                      }
                                      className="cursor-pointer hover:opacity-80 transition-opacity duration-200"
                                    />
                                    <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-1 bg-gray-800 text-white text-xs rounded-md whitespace-nowrap opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity duration-300 pointer-events-none z-10 text-wrap">
                                      Deleting will mark payment as not paid.
                                    </div>
                                  </div>
                                )}
                              </td>
                            </>
                          )}
                        </tr>
                      );
                    })}
                  </React.Fragment>
                ));
              })()
            ) : (
              <tr>
                <td colSpan="10" className="text-center py-10 text-gray-500">
                  {displayAll
                    ? "No payments match your current filters."
                    : "No payment data available."}
                </td>
              </tr>
            )}
          </tbody>
          {/**********************************
           *  INCOMPLETE CODE ENDS HERE      *
           **********************************/}
        </table>
      </div>

      {/* Pagination and Modals */}
      {!limitRows && displayAll && nextPageToken && nextPageToken !== "END" && (
        <div className="flex justify-start mt-6">
          <button
            onClick={handleNext}
            disabled={isLoading}
            className={`px-8 py-2.5 rounded-lg font-medium text-white transition-colors ${isLoading ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"}`}
          >
            {isLoading ? "Loading..." : "Show More"}
          </button>
        </div>
      )}

      <PaymentModal
        isVisible={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
        paymentDetails={selectedPayment}
        deleteRecord={handleDeleteClick}
      />
      <DialogModal
        show={showDeleteConfirmModal}
        onClose={() => {
          setShowDeleteConfirmModal(false);
          setPaymentToDelete(null);
        }}
        title="Confirm Deletion"
        footerButtons={
          <>
            <button
              onClick={() => {
                setShowDeleteConfirmModal(false);
                setPaymentToDelete(null);
              }}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={confirmDeleteAction}
              className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 transition-colors"
            >
              Delete
            </button>
          </>
        }
      >
        <p className="text-center">
          Are you sure you want to delete this transaction?
          <br />
          <span className="font-semibold text-red-700">
            This will mark the payment as 'not paid'.
          </span>
        </p>
      </DialogModal>
    </div>
  );
};

export default CustomComponent;
